import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Log, LogDetail } from '../../../../../../../types/log.interface';
import { LogDetailItemComponent } from './log-detail-item.component';

interface DetailGroup {
  key: string;
  details: LogDetail[];
}

@Component({
  selector: 'ces-log-content',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LogDetailItemComponent, TranslocoModule],
  templateUrl: './log-content.component.html',
})
export class LogContentComponent {
  readonly log = input.required<Log>();

  readonly groupedDetails = computed<DetailGroup[]>(() => {
    const details = this.log().details ?? [];
    const groups: DetailGroup[] = [];
    const fileGroupMap = new Map<string, DetailGroup>();

    for (const detail of details) {
      const isFileOp = detail.entity === 'campaign-info' && (detail.attribute === 'file' || detail.attribute === 'image');

      if (isFileOp) {
        const key = `${detail.entityId}-${detail.attribute}`;
        const existing = fileGroupMap.get(key);
        if (existing) {
          existing.details.push(detail);
        } else {
          const group: DetailGroup = { key, details: [detail] };
          fileGroupMap.set(key, group);
          groups.push(group);
        }
      } else {
        groups.push({ key: `${detail.id}`, details: [detail] });
      }
    }

    return groups;
  });
}
